import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import logo from '../../../assets/casper-logo.png';
import { useColorScheme } from '@mui/material/styles';
import logo_dark from '../../../assets/casper-logo-dark.png';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';
import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded';

const items = [
  {
    icon: <SettingsSuggestRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Desempenho adaptável',
    description:
      'Nosso produto se ajusta facilmente às suas necessidades, aumentando a eficiência e simplificando suas tarefas.',
  },
  {
    icon: <ConstructionRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Feito para durar',
    description:
      'Experimente uma durabilidade incomparável que supera expectativas e representa um investimento duradouro.',
  },
  {
    icon: <ThumbUpAltRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Ótima experiência do usuário',
    description:
      'Integre nosso produto à sua rotina com uma interface intuitiva e fácil de usar.',
  },
  {
    icon: <AutoFixHighRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Funcionalidade inovadora',
    description:
      'Mantenha-se à frente com recursos que estabelecem novos padrões, atendendo às suas necessidades em constante evolução.',
  },
];

export default function Content() {
  const { mode } = useColorScheme();

  return (
    <Stack sx={{ flexDirection: 'column', alignSelf: 'center', gap: 3, maxWidth: 450 }} >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'left',
          mt: 2,
          '& img': {
            width: { xs: '150px', sm: '150px', md: '150px' }, 
            height: 'auto',
          }
        }}
      >
        <img  src={mode === 'dark' ? logo_dark : logo} alt="logo sulpasso" />
      </Box>
      {items.map((item, index) => (
        <Stack key={index} direction="row" sx={{ gap: 2 }}>
          {item.icon}
          <div>
            <Typography gutterBottom sx={{ fontWeight: 'medium' }}>
              {item.title}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {item.description}
            </Typography>
          </div>
        </Stack>
      ))}
    </Stack>
  );
}
